module.exports = __webpack_public_path__ + "static/media/front_end_manager_experience.894b68b7.png";